module.exports = __webpack_public_path__ + "static/aire-acondicionado-104a74767604cc2e6ed51538dcb3a356.jpg";